module.exports = __webpack_public_path__ + "img/bitcoin-big-bang.48f031fe.gif";